/* eslint-disable no-undef */
import * as request from "@utils/request"

export function initYodaJSSDK() {
  if (window.KSYoda) {
    return Promise.resolve(window.KSYoda)
  } else {
    return request.getScript("https://static.yximgs.com/udata/pkg/fe/yoda.full.0.4.1.min.a5a2b8a091c3cd60.js").then(() => {
      return window.KSYoda
    })
  }
}

async function canUseBridge(bridgeName, namespace = "kwai") {
  await initYodaJSSDK()
  // 非 yoda 环境，无法使用 bridge
  if (!KSYoda.isInYoda) {
    console.warn("not ks yoda env")
    return false
  }
  // 等待初始化完毕
  await KSYoda.ready()
  // 判断 bridge 是否可用
  if (!KSYoda[namespace] || !KSYoda[namespace][bridgeName]) {
    console.warn(`bridge ${namespace}.${bridgeName} not exist`)
    return false
  }
  return true
}

// 吊起小程序，绑定 livelink
export async function openWechatMiniProgram({ path }) {
  const canUse = await canUseBridge("openWechatMiniProgram")
  if (!canUse) {
    return
  }

  await KSYoda.kwai.openWechatMiniProgram({
    originalID: "gU_Golw1tkr-fDnVtGpY_g", // 微信小程序原始 ID，AES 加密(如果是新的小程序，把原始 id 给到@辛洋汐给加密 ID)
    path: path // 跳转到微信小程序对应的 path 页面,
  })
}
